exports = module.exports = require("./../../../node_modules/.0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".popup-enter-active,.popup-leave-active{transition:all .2s}.popup-enter,.popup-leave-active{opacity:0}.weui-dialog{left:10%;top:35%;max-width:none;transform:scaleX(1)}", "", {"version":3,"sources":["/./src/components/popup/dialog.vue"],"names":[],"mappings":"AACA,wCAAwC,kBAAkB,CACzD,AACD,iCAAiC,SAAS,CACzC,AACD,aAAa,SAAS,QAAQ,eAAe,mBAA0B,CACtE","file":"dialog.vue","sourcesContent":["\n.popup-enter-active,.popup-leave-active{transition:all .2s\n}\n.popup-enter,.popup-leave-active{opacity:0\n}\n.weui-dialog{left:10%;top:35%;max-width:none;transform:scale3d(1, 1, 1)\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.25.0@css-loader?sourceMap!./~/.10.0.2@vue-loader/lib/style-rewriter.js?id=data-v-bc107180!./~/.2.2.3@less-loader?sourceMap!./~/.10.0.2@vue-loader/lib/selector.js?type=styles&index=0!./src/components/popup/dialog.vue
// module id = 104
// module chunks = 0